export default {"src":"https://s.sylndr.me/c-a7be377/_next/static/media/websiteLogoEn.c4c26a6a.svg","height":655,"width":4096,"blurWidth":0,"blurHeight":0};